import {  useState } from "react";
import { Row, Col } from "react-bootstrap"
import axiosService from "../../../utils/axios.service";
import "../scss/report.scss"
import { Table, Button } from 'antd';
import 'antd/dist/antd.min.css'
import Loading from "../../customer/Loading";

// Chi tiết KTV - Tổng quan phục vụ
const ViewDetailServiceUser = (props) => {
    const [showLoading, setShowLoading] = useState(false)
    const [pageSize, setPageSize] = useState(10)

    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };

    const columns = [
        {
            title: 'Tên dịch vụ',
            dataIndex: 'service_name',
            // align: "center",
            fixed : 'left',
            width: 150,
            render: (data) => {
                return (
                    <p className="text1">{data}</p>
                )
            },
        },
        {
            title: 'Tổng số lượt phục vụ',
            dataIndex: 'count_ktv',
            align: "center",
            width: 150,
            render: (data) => {
                return (
                    <p className="">{data}</p>
                )
            },
        },
        {
            title: 'Thưởng phục vụ',
            dataIndex: 'com_ktv',
            align: "center",
            width: 150,

            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(Number(data))}</p>
                )
            },
        },
    ];

    const handelExportUser = () => {
        setShowLoading(true)
      
        var url = `api/mysql/export/detail-user?type=1&user_id=${props.userId}&user_name=${props.userName}&start=${props.startDate}&end=${props.endDate}`
        axiosService(url, "GET")
        .then((res) => {
            if (res.data.code == 200) {
                window.location.href = res.data.data.url
                setShowLoading(false)
            }
        }).catch((error) => {
            console.log(error)
            setShowLoading(false)
        });
    }
    const  handleChange = (e) => {
        setPageSize(e.pageSize)
    }

  
    return (
        <>
            <div style={{ backgroundColor: "white" }} className="p-2">
                <div className="border-bottom w-100 pb-2">
                    <Row>
                        <Col xs={6}>
                            <div>
                                Bảng số liệu chi tiết
                            </div>
                        </Col>
                        <Col xs={6}>
                            <Button size="middle" type="primary"
                             onClick={handelExportUser}
                            ><i className="fa-solid fa-file-excel mr-2"></i>Xuất dữ liệu
                            </Button>
                        </Col>
                    </Row>
                </div>
                    
                <Table 
                    columns={columns} 
                    dataSource={props.table}
                    pagination={{ pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['10', '15', '30', '50', '100'] }}
                    scroll={{ x: columns.length*150, y: 600 }}
                    onChange={handleChange}
                    bordered
                    rowKey={(record, index) => index}
                />
            </div>
            <Loading
                show={showLoading}
            ></Loading>
        </>
    )
}
export default ViewDetailServiceUser